export default "__VITE_ASSET__BG9xD5SB__"